/* Aurant · carrito propio: lo que hace. Lo arma _PROGRAMA/armar_carrito.py: no se edita a mano.
   Lo que se ve está en sections/aurant-carrito.liquid, dentro de un shadow DOM. Aquí va: abrir y cerrar, la cuenta de la reserva,
   sumar, restar, quitar y agregar, y volver a pintar el carrito UNA vez después de cada cambio.
   En la tienda de referencia esto lo hacía el programa de su armador de páginas, que no se puede copiar: se escribió de nuevo sobre
   los mismos ganchos (data-cart-*), partiendo de sus scripts cortos (la cuenta regresiva y el cuadre de regalos).
   Orden de cada cambio: 1) se manda a Shopify, 2) AurantRegalos.cuadrar() deja los regalos que tocan, 3) se pinta una sola vez.
   Para no pedir de más, en cada llamada se le pide a Shopify el carrito ya pintado (sections=aurant-carrito,cart-icon-bubble).
   Si no viene, se pide aparte con /?sections=aurant-carrito,cart-icon-bubble.
   Uso desde otras piezas: AurantCarrito.abrir(), AurantCarrito.cerrar() y AurantCarrito.refrescar({ abrir: true }), que devuelve una promesa. */
(function () {
  if (window.AurantCarrito && window.AurantCarrito.version) { return; }
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECCIONES = 'aurant-carrito,cart-icon-bubble';
  var CLAVE_RESERVA = 'aurant_carrito_reserva';
  var EN_PAGINA_CARRITO = /\/cart\/?$/.test(window.location.pathname);
  var enCurso = null, espera = null, abridor = null, tic = null, relojAviso = null, estiloBurbuja = null, reservaMemoria = null, bloqueado = null;
  var vigia = null, esperaHoja = null, huboCambio = false;
  var cuenta = { repintados: 0 };                 // cuántas veces se pintó el carrito. Sirve para las pruebas.

  /* Todo vive dentro del shadow DOM del carrito. Se busca por su marca, no «el último de la página»: la página de producto y la colección tienen el suyo. */
  function anfitrion() { return document.querySelector('aurant-layout[data-aurant="carrito"]'); }
  function raiz() { var h = anfitrion(); return h && h.shadowRoot ? h.shadowRoot : null; }
  function uno(sel) { var r = raiz(); return r ? r.querySelector(sel) : null; }
  function panel() { return uno('[data-cart-overlay]'); }
  function abierto() { var p = panel(); return !!p && p.getAttribute('data-state') === 'open'; }
  function zona(n) { return uno('[data-cart-update="' + n + '"]'); }
  function dos(n) { return (n < 10 ? '0' : '') + n; }

  // ---------- la caja nace escondida y se destapa cuando la hoja del carrito ya está puesta
  /* La caja de afuera viene con display:none escrito en ella (ver sections/aurant-carrito.liquid). Lo que deja al carrito fijo y escondido
     está en su hoja (assets/aurant-carrito.css): mientras no llega, el carrito se vería desarmado arriba de la página.
     Aquí se destapa recién cuando el panel ya está en posición fija, que es la señal de que la hoja se aplicó. Nunca antes.
     Si la hoja no llega nunca, la caja no se destapa: el cliente que toca el carrito va a la página /cart del tema. */
  function destapar() {
    var h = anfitrion(), c = h && h.parentNode, r = raiz(), p = panel();
    if (!c || !c.style || !r || !p) { return false; }
    if (c.style.display !== 'none') { return true; }
    var l = r.querySelector('link[data-aur-hoja]');
    if (l && l.sheet && l.media !== 'all') { l.media = 'all'; }      // por si el onload del enlace no corrió
    if (window.getComputedStyle(p).position !== 'fixed') { return false; }
    c.style.display = '';
    void p.offsetWidth;                                               // deja el carrito cerrado ya dibujado, para que al abrir entre deslizándose
    return true;
  }
  /* Mira cada 150 ms, hasta 15 segundos. Después se vuelve a mirar cada vez que alguien pide abrir. */
  function vigilar() {
    if (vigia || destapar()) { return; }
    var n = 0;
    vigia = setInterval(function () { if (destapar() || ++n >= 100) { clearInterval(vigia); vigia = null; } }, 150);
  }
  function aLaPagina() { if (!EN_PAGINA_CARRITO && !(window.Shopify && Shopify.designMode)) { window.location.href = R + 'cart'; } }
  /* Piden abrir y la hoja todavía no está puesta: se espera hasta 3 segundos. Si no llega, a la página /cart, donde el cliente puede pagar. */
  function esperarHoja(quien) {
    if (esperaHoja) { return; }
    var n = 0;
    esperaHoja = setInterval(function () {
      if (destapar()) { clearInterval(esperaHoja); esperaHoja = null; abrir(quien); }
      else if (++n >= 20) { clearInterval(esperaHoja); esperaHoja = null; aLaPagina(); }
    }, 150);
  }

  // ---------- llamadas a Shopify
  function pedir(url, opc) {
    return fetch(url, opc).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, estado: r.status, j: j }; }, function () { return { ok: false, estado: r.status, j: {} }; });
    }, function () { return { ok: false, estado: 0, j: {} }; });
  }
  function mandar(ruta, cuerpo) {
    cuerpo.sections = SECCIONES; cuerpo.sections_url = window.location.pathname;
    return pedir(R + ruta, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(cuerpo) });
  }
  function esCarrito(j) { return !!j && Array.isArray(j.items) && typeof j.item_count === 'number'; }
  function mensaje(res, tipo) {
    /* Si la tienda está en español, el aviso de Shopify ya viene en español y dice el detalle. Si no, va uno propio. */
    var d = res.j && (res.j.description || res.j.message), es = /^es/i.test(document.documentElement.lang || '');
    if (es && typeof d === 'string' && d && res.estado === 422) { return d; }
    if (res.estado === 422) { return tipo === 'agregar' ? 'Este producto está agotado por ahora.' : 'No quedan más unidades de este producto.'; }
    return 'No se pudo actualizar el carrito. Revisa tu conexión e inténtalo de nuevo.';
  }
  function aviso(txt) {
    var a = uno('[data-aur-aviso]');
    clearTimeout(relojAviso);
    if (!a) { return; }
    if (!txt) { a.hidden = true; a.textContent = ''; return; }
    a.textContent = txt; a.hidden = false;
    relojAviso = setTimeout(function () { a.hidden = true; }, 7000);
  }

  // ---------- cuenta regresiva de la reserva
  /* Parte del tiempo del ajuste (4:27) la primera vez que el cliente ve el carrito abierto con algo adentro, baja cada segundo y se queda en 00:00.
     La hora de término se guarda en la pestaña (sessionStorage): no se reinicia cuando el carrito se vuelve a pintar ni al cambiar de página.
     Si el carrito queda vacío, la reserva se olvida y el próximo pedido parte de nuevo. La referencia cambiaba el texto al llegar a cero: aquí no pasa nada. */
  function reservaLeer() { try { return JSON.parse(sessionStorage.getItem(CLAVE_RESERVA) || 'null'); } catch (e) { return reservaMemoria; } }
  function reservaGuardar(v) { reservaMemoria = v; try { if (v) { sessionStorage.setItem(CLAVE_RESERVA, JSON.stringify(v)); } else { sessionStorage.removeItem(CLAVE_RESERVA); } } catch (e) {} }
  function reloj() {
    var t = uno('[data-reserve-timer]');
    if (!t) {
      var d = uno('[data-gift-reconcile]');
      if (d && d.getAttribute('data-aur-articulos') === '0' && reservaLeer()) { reservaGuardar(null); }
      return;
    }
    var seg = parseInt(t.getAttribute('data-aur-segundos'), 10) || 267, g = reservaLeer();
    if (!g || g.seg !== seg || !g.fin) {
      if (!abierto()) { return; }
      g = { fin: Date.now() + seg * 1000, seg: seg }; reservaGuardar(g);
    }
    var q = Math.max(0, Math.round((g.fin - Date.now()) / 1000)), txt = dos(Math.floor(q / 60)) + ':' + dos(q % 60);
    if (t.textContent !== txt) { t.textContent = txt; }
  }

  // ---------- el número del ícono del carrito de la cabecera
  /* Lo mismo que hace el cajón de Elixir con la sección cart-icon-bubble: cambia el contenido del enlace y deja a la vista el dibujo que toca. */
  function icono(html) {
    var a = document.getElementById('cart-icon-bubble');
    if (!a || typeof html !== 'string' || !html) { return; }
    var s = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (!s) { return; }
    var tipo = a.getAttribute('data-cart-icon-type'), vieja = a.querySelector('.cart-count-bubble');
    if (vieja && vieja.getAttribute('style')) { estiloBurbuja = vieja.getAttribute('style'); }
    a.innerHTML = s.innerHTML;
    var nueva = a.querySelector('.cart-count-bubble'), env = a.querySelector('.svg-wrapper');
    if (nueva && estiloBurbuja) { nueva.setAttribute('style', estiloBurbuja); }   // los colores que le puso la cabecera
    if (!env) { return; }
    var dibujo = tipo === 'bag' ? env.querySelector('.cart-icon-bag') : ((!nueva && env.querySelector('.cart-icon-cart-empty')) || env.querySelector('.cart-icon-cart'));
    if (dibujo) { dibujo.style.display = 'flex'; }
  }

  // ---------- pintar
  function firmaTarjetas(z) {
    return Array.prototype.map.call(z.querySelectorAll('[data-cart-add]'), function (b) { return b.getAttribute('data-variant-id') + '|' + b.textContent.replace(/\s+/g, ' '); }).join(',');
  }
  /* Cambia el contenido de las zonas del carrito por el que manda Shopify. No se toca la caja de afuera: por eso el carrito sigue abierto,
     la lista no pierde su posición y la franja de reserva sigue su cuenta. En la respuesta el carrito viene dentro de <template shadowrootmode>:
     al leerla como texto ese template no se enciende solo, así que se toma su contenido. */
  function pintar(secciones) {
    var html = secciones && secciones['aurant-carrito'], r = raiz();
    if (typeof html !== 'string' || !html || !r) { return false; }
    var h = new DOMParser().parseFromString(html, 'text/html').querySelector('aurant-layout[data-aurant="carrito"]');
    var t = h && h.querySelector('template'), nuevo = t ? t.content : (h && h.shadowRoot);
    if (!nuevo || !nuevo.querySelector('[data-cart-update]')) { return false; }
    var lista = r.querySelector('.ic-scroll'), alto = lista ? lista.scrollTop : 0;
    Array.prototype.forEach.call(r.querySelectorAll('[data-cart-update]'), function (z) {
      var nombre = z.getAttribute('data-cart-update'), n = nuevo.querySelector('[data-cart-update="' + nombre + '"]');
      if (!n) { return; }
      /* «Complementa tu pedido»: si trae las mismas tarjetas, no se toca, para que el carrusel no vuelva a la primera. */
      if (nombre === 'upsell') { var f = firmaTarjetas(n); if (f && f === firmaTarjetas(z)) { return; } }
      z.innerHTML = n.innerHTML;
    });
    if (lista) { lista.scrollTop = alto; }
    cuenta.repintados += 1;
    reloj(); carrusel(); icono(secciones['cart-icon-bubble']);
    return true;
  }
  /* Después de un cambio: cuadra los regalos y pinta una vez. «respuesta» es lo que devolvió Shopify en la última llamada. */
  function terminar(respuesta, opc) {
    var AR = window.AurantRegalos, conocido = opc.carrito || respuesta;
    var c = (opc.cuadrado || !AR || !AR.cuadrar) ? Promise.resolve(null)
      : AR.cuadrar({ carrito: esCarrito(conocido) ? conocido : null, secciones: SECCIONES }).then(null, function () { return null; });
    return c.then(function (r) {
      if (r && r.cambio) { huboCambio = true; }
      /* Si los regalos cambiaron algo, vale lo que vino con ese cambio. Si no, lo que vino con la llamada del cliente. */
      var s = (r && r.cambio) ? r.secciones : (respuesta && respuesta.sections);
      if (s && pintar(s)) { return true; }
      return pedir(R + '?sections=' + SECCIONES, { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (g) { return g.ok ? pintar(g.j) : false; });
    });
  }

  // ---------- estado de espera: mientras hay una llamada en curso, el carrito no recibe otro toque
  function ocupar(si, boton) {
    ['items', 'upsell'].forEach(function (n) { var z = zona(n); if (z) { if (si) { z.setAttribute('aria-busy', 'true'); } else { z.removeAttribute('aria-busy'); } } });
    if (boton) { if (si) { boton.setAttribute('aria-busy', 'true'); } else { boton.removeAttribute('aria-busy'); } }
  }
  function accion(hacer, boton, tipo) {
    if (enCurso) { return Promise.resolve(false); }
    ocupar(true, boton); aviso('');
    var p = hacer().then(function (res) {
      if (!res.ok) { aviso(mensaje(res, tipo)); return terminar(null, { cuadrado: true }); }
      huboCambio = true;
      return terminar(res.j, {});
    }).then(function () { return true; }, function () { return false; }).then(function (v) { ocupar(false, boton); if (enCurso === p) { enCurso = null; } return v; });
    enCurso = p;
    return p;
  }
  function campoDe(clave) {
    var r = raiz(), l = r ? r.querySelectorAll('[data-cart-quantity]') : [];
    for (var i = 0; i < l.length; i++) { if (l[i].getAttribute('data-line-key') === clave) { return l[i]; } }
    return null;
  }
  function cambiarLinea(clave, cantidad, boton) {
    if (!clave) { return; }
    return accion(function () { return mandar('cart/change.js', { id: clave, quantity: cantidad }); }, boton, 'cantidad');
  }
  function agregar(boton) {
    var id = Number(boton.getAttribute('data-variant-id')), plan = boton.getAttribute('data-selling-plan');
    if (!id || enCurso) { return; }
    var linea = { id: id, quantity: 1 }, AR = window.AurantRegalos, regalos = [];
    if (plan) { linea.selling_plan = Number(plan); }
    /* Los regalos que tocarán con este bálsamo van en la misma llamada. Si con ellos Shopify la rechaza, se manda solo el bálsamo. */
    try { if (AR && AR.paraAgregar) { regalos = AR.paraAgregar([linea]) || []; } } catch (e) {}
    return accion(function () {
      return mandar('cart/add.js', { items: [linea].concat(regalos) }).then(function (res) {
        if (!res.ok && regalos.length) { return mandar('cart/add.js', { items: [linea] }); }
        return res;
      });
    }, boton, 'agregar');
  }
  function alClic(e) {
    var t = e.target, b;
    if (!t || !t.closest) { return; }
    if (t.closest('[data-cart-close]')) { cerrar(); return; }
    if ((b = t.closest('[data-cart-plus]')) || (b = t.closest('[data-cart-minus]'))) {
      var clave = b.getAttribute('data-line-key'), campo = campoDe(clave), hay = campo ? (parseInt(campo.value, 10) || 0) : 0;
      cambiarLinea(clave, Math.max(0, hay + (b.hasAttribute('data-cart-plus') ? 1 : -1)), b);
      return;
    }
    if ((b = t.closest('[data-cart-remove]'))) {
      if (enCurso) { return; }
      var k = b.getAttribute('data-line-key'), AR = window.AurantRegalos;
      /* Si es un regalo, se anota que el cliente lo quitó: no se le vuelve a meter solo hasta que agregue un bálsamo o vacíe el carrito. */
      if (b.closest('[data-cart-line="regalo"]') && AR && AR.rechazar) { AR.rechazar(b.getAttribute('data-variant-id') || String(k).split(':')[0]); }
      cambiarLinea(k, 0, b);
      return;
    }
    if ((b = t.closest('[data-cart-add]'))) { agregar(b); }
  }
  function alCambio(e) {
    var c = e.target;
    if (!c || !c.matches || !c.matches('[data-cart-quantity]')) { return; }
    var n = parseInt(c.value, 10);
    if (isNaN(n) || n < 0 || enCurso) { c.value = c.defaultValue; return; }
    cambiarLinea(c.getAttribute('data-line-key'), n, null);
  }

  // ---------- abrir y cerrar
  function bloquear(si) {   // la página de atrás no se desplaza mientras el carrito está abierto
    var h = document.documentElement, b = document.body;
    if (si && !bloqueado) {
      bloqueado = { h: h.style.overflow, b: b.style.overflow, p: b.style.paddingRight };
      var barra = window.innerWidth - h.clientWidth;
      h.style.overflow = 'hidden'; b.style.overflow = 'hidden';
      if (barra > 0) { b.style.paddingRight = barra + 'px'; }
    } else if (!si && bloqueado) {
      h.style.overflow = bloqueado.h; b.style.overflow = bloqueado.b; b.style.paddingRight = bloqueado.p; bloqueado = null;
    }
  }
  function firmaDe(cart) { return (cart.items || []).map(function (i) { return i.variant_id + 'x' + i.quantity + ':' + i.final_line_price + ';'; }).join(''); }
  /* ¿Lo pintado es lo que hay en Shopify? Una llamada corta. Solo si no calza (el carrito cambió en otra pestaña, o la página vino guardada) se repinta. */
  function comprobar() {
    if (enCurso) { return Promise.resolve(false); }
    return pedir(R + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) {
      var d = uno('[data-gift-reconcile]');
      if (!r.ok || !esCarrito(r.j) || !d || enCurso) { return false; }
      if ((d.getAttribute('data-aur-firma') || '') === firmaDe(r.j)) { return false; }
      return refrescar({ carrito: r.j }).then(function () { return true; });
    });
  }
  function mostrar(quien) {
    var p = panel();
    if (!p) { return false; }
    enlazar();
    /* Sin su hoja el carrito no se muestra: se espera un momento a que llegue. */
    if (!destapar()) { esperarHoja(quien); return false; }
    if (!abierto()) {
      abridor = (quien && quien.focus) ? quien : document.activeElement;
      p.setAttribute('data-state', 'open');
      bloquear(true);
      var x = p.querySelector('button[data-cart-close]');
      if (x) { try { x.focus({ preventScroll: true }); } catch (e) {} }
      if (!tic) { tic = setInterval(reloj, 1000); }
    }
    reloj();
    return true;
  }
  function abrir(quien) { if (mostrar(quien)) { comprobar(); } }
  function cerrar() {
    var p = panel();
    if (!p || !abierto()) { return; }
    p.setAttribute('data-state', 'closed');
    bloquear(false);
    if (tic) { clearInterval(tic); tic = null; }
    if (abridor && abridor.focus) { try { abridor.focus({ preventScroll: true }); } catch (e) {} }
    abridor = null;
    /* En la página /cart, detrás del carrito propio está la lista del tema. Si aquí se cambió algo, esa lista quedó vieja
       (revisión del 09-oct-2026): al cerrar se recarga la página, una vez, para que muestre lo mismo que se va a pagar. */
    if (EN_PAGINA_CARRITO) {
      var alDia = function () { if (huboCambio && !abierto()) { huboCambio = false; window.location.reload(); } };
      if (enCurso) { enCurso.then(alDia, alDia); } else { alDia(); }   // si hay un cambio viajando, se espera a que termine
    }
  }
  function alTeclado(e) {
    if (!abierto()) { return; }
    if (e.key === 'Escape' || e.keyCode === 27) { cerrar(); return; }
    if (e.key !== 'Tab') { return; }
    /* El foco no sale del carrito mientras está abierto. */
    var p = panel(), r = raiz();
    if (!p || !r) { return; }
    var l = Array.prototype.filter.call(p.querySelectorAll('a[href],button:not([disabled]),input:not([tabindex="-1"])'), function (el) { return el.getClientRects().length > 0; });
    if (!l.length) { return; }
    var i = l.indexOf(r.activeElement);
    if (i === -1 || (!e.shiftKey && i === l.length - 1)) { e.preventDefault(); l[0].focus(); }
    else if (e.shiftKey && i === 0) { e.preventDefault(); l[l.length - 1].focus(); }
  }

  // ---------- refrescar: lo llaman la página de producto, el puente con el cajón de Elixir y la pieza de regalos
  /* opc.abrir: abre el carrito al terminar. opc.cuadrado: quien llama ya cuadró los regalos, no se cuadra otra vez.
     Si llega mientras hay otra llamada en curso, no se pierde ni se duplica: queda una sola pasada pendiente para cuando termine. */
  function refrescarYa(opc) {
    ocupar(true, null);
    var p = terminar(null, opc).then(function (v) { return v; }, function () { return false; }).then(function (v) {
      ocupar(false, null); if (enCurso === p) { enCurso = null; }
      if (opc.abrir) { mostrar(null); }
      return v;
    });
    enCurso = p;
    return p;
  }
  function refrescar(opc) {
    opc = opc || {};
    if (!raiz()) { return Promise.resolve(false); }
    enlazar();
    if (!enCurso) { return refrescarYa(opc); }
    if (!espera) {
      espera = { abrir: false, cuadrado: true };
      espera.promesa = enCurso.then(function () { var e = espera; espera = null; return refrescar({ abrir: e.abrir, cuadrado: e.cuadrado }); });
    }
    if (opc.abrir) { espera.abrir = true; }
    if (!opc.cuadrado) { espera.cuadrado = false; }
    return espera.promesa;
  }

  // ---------- el carrusel de «Complementa tu pedido»: el mismo de la página de producto. Se pide solo cuando hay tarjetas y la página no lo trae.
  function carrusel() {
    var r = raiz();
    if (!r || !r.querySelector('swiper-container')) { return; }
    if ((window.customElements && window.customElements.get('swiper-container')) || document.querySelector('script[src*="aurant-swiper"]')) { return; }
    var caja = document.querySelector('[data-aur-carrusel]'), src = caja && caja.getAttribute('data-aur-carrusel');
    if (!src) { return; }
    var s = document.createElement('script'); s.src = src; document.head.appendChild(s);
  }

  function enlazar() {
    var r = raiz();
    if (!r) { return false; }
    if (r.__aurant) { return true; }
    r.__aurant = 1;
    r.addEventListener('click', alClic);
    r.addEventListener('change', alCambio);
    r.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-cart-quantity]')) { e.preventDefault(); e.target.blur(); } });
    carrusel(); reloj();
    return true;
  }

  window.AurantCarrito = { version: 1, abrir: abrir, cerrar: cerrar, refrescar: refrescar, cuenta: cuenta };
  document.addEventListener('keydown', alTeclado);
  /* En el editor del tema la sección se vuelve a pintar entera: hay que volver a enlazar y a destapar la caja nueva. */
  document.addEventListener('shopify:section:load', function () { setTimeout(function () { enlazar(); vigilar(); }, 0); });
  window.addEventListener('load', vigilar);
  /* Página que vuelve desde la memoria del navegador (botón «atrás»): el carrito pintado puede ser viejo. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) { comprobar(); } });
  function partir() {
    enlazar(); vigilar();
    /* Si alguien pidió abrir o refrescar antes de que esta pieza cargara, se atiende ahora. */
    var p = window.__aurantPendiente; window.__aurantPendiente = null;
    if (p && p.que && window.AurantCarrito[p.que]) { window.AurantCarrito[p.que](p.opc); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', partir); } else { partir(); }
})();
